"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = void 0;
class Data {
}
exports.Data = Data;
//# sourceMappingURL=Data.js.map